import { cn } from "@/lib/utils";
import { Spinner } from "./Spinner";

export type LoadingStateProps = {
  label?: string;
  className?: string;
};

export function LoadingState({ label = "Loading…", className }: LoadingStateProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 font-mono text-mono text-fg-3 px-1 py-2",
        className,
      )}
    >
      <Spinner size="sm" />
      <span>{label}</span>
    </div>
  );
}
